import React from 'react';
import classNames from 'classnames';
import { useField } from 'react-final-form';
import isEqual from 'lodash/isEqual';
import ManageColumnsList from 'components/ManageColumnsList';
import { EMPTY_ARRAY } from 'data/global';

import './ManageColumnsField.styles.scss';

type ManageColumnsFieldProps = {
  className?: string;
  headingTranslations: Record<string, string>;
  lockedColumn?: string;
};

const ManageColumnsField: React.FC<ManageColumnsFieldProps> = (props) => {
  const { className, headingTranslations, lockedColumn } = props;

  const classes = classNames('manage-columns-field', className);

  const {
    input: { value: hiddenColumns = EMPTY_ARRAY, onChange: onHiddenChange },
  } = useField<string[]>('hiddenColumns', { isEqual });

  const {
    input: { value: columnOrder = EMPTY_ARRAY, onChange: onOrderChange },
  } = useField<string[]>('columnOrder', { isEqual });

  return (
    <ManageColumnsList
      className={classes}
      allColumns={columnOrder}
      hiddenColumns={hiddenColumns}
      headingTranslations={headingTranslations}
      lockedColumn={lockedColumn}
      onHiddenColumnsChange={onHiddenChange}
      onReorderAll={onOrderChange}
    />
  );
};

export default ManageColumnsField;
